import PlatformModalLayer from '../utils/PlatformModalLayer';
import React, { useMemo } from 'react';
import './deposit.scss';
import './BankDetails.scss';
import { FiCopy, FiX } from 'react-icons/fi';
import { useAccountManagerContext } from '../../contexts/Account-Manager-Context';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const BankDetails = () => {
    const { t } = useTranslation();
    const { setShowBank, bankDetails } = useAccountManagerContext();
    const rows = useMemo(() => {
        const doc = new DOMParser().parseFromString(bankDetails?.description || '', 'text/html');
        doc.querySelectorAll('script, style').forEach(node => node.remove());
        doc.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
        doc.querySelectorAll('p, div, li, tr').forEach(node => node.append('\n'));
        return (doc.body.textContent || '').split('\n').map(line => line.trim()).filter(Boolean).map(line => {
            const colon = line.indexOf(':');
            return colon > 0 ? { label: line.slice(0, colon).trim(), value: line.slice(colon + 1).trim() } : { label: '', value: line };
        });
    }, [bankDetails?.description]);

    const copy = async (text, all = false) => {
        try {
            await navigator.clipboard.writeText(text);
            toast.success(all ? t('bankDetails.copiedDetails') : t('bankDetails.copiedItem', { text }), { position: 'top-right' });
        } catch (err) {
            console.error('Failed to copy bank details:', err);
        }
    };
    const allText = rows.map(({ label, value }) => label ? `${label}: ${value}` : value).join('\n');

    return (
        <PlatformModalLayer className="dialog-modal-1 bank-details-modal" role="true">
            <div className="card bank-details-card" role="dialog" aria-modal="true" aria-labelledby="bank-details-title">
                <header className="bank-details-header">
                    <h2 id="bank-details-title">{t('bankDetails.title')}</h2>
                    <button type="button" className="popup-close-button" aria-label={t('common.close')} onClick={() => setShowBank(false)}><FiX aria-hidden="true" /></button>
                </header>
                <dl className="bank-details-fields">
                    {rows.map(({ label, value }, index) => (
                        <div className={`bank-details-field${label ? '' : ' bank-details-note'}`} key={index}>
                            {label && <dt>{label}</dt>}
                            <dd>
                                <span>{value}</span>
                                {label && value && <button type="button" className="bank-details-copy-value" aria-label={`${t('bankDetails.copy')} ${label}`} onClick={() => copy(value)}><FiCopy aria-hidden="true" /></button>}
                            </dd>
                        </div>
                    ))}
                </dl>
                <footer className="bank-details-actions">
                    <button type="button" className="bank-details-copy-all" disabled={!allText} onClick={() => copy(allText, true)}><FiCopy aria-hidden="true" />{t('bankDetails.copy')}</button>
                </footer>
            </div>
        </PlatformModalLayer>
    );
};
export default BankDetails;
